export { default as DespachoPlantaGrid } from './Listar';
export { default as DespachoPlantaCrear } from './Crear';
export { default as DetalleDespachoPlanta} from './Detalle';